// removed by extract-text-webpack-plugin
module.exports = {"VehicleCell":"VehicleCell--3LTyZ"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Sensor/SensorGrid/SensorGrid.scss
// module id = 951
// module chunks = 1